import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ChevronDownBold = () => (
  <svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.75 0.75L4.75 4.75L0.75 0.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fill: 'none' }}
    />
  </svg>
)

export default withDefaultStyles(ChevronDownBold)
